import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmailDashboardRoutingModule } from './email-dashboard-routing.module';
import { CoreModule } from '../../core/core.module';
import { EmailDashboardComponent } from './email-dashboard.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropdownModule, AutoCompleteModule, TreeTableModule } from 'primeng/primeng';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';


@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    NgbModule,
    FormsModule,
    AutoCompleteModule,
    TableModule,
    TreeTableModule,
    EmailDashboardRoutingModule
  ],
  declarations: [EmailDashboardComponent],
})
export class EmailDashboardModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.module.ts